import { render, staticRenderFns } from "./SARedeemsWrapper.vue?vue&type=template&id=e9234aca"
import script from "./SARedeemsWrapper.vue?vue&type=script&lang=js"
export * from "./SARedeemsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports